import React, { useEffect, useState } from "react";
import { FaPlus, FaTrash } from "react-icons/fa";
import {
  useCreateItem,
  useUpdateItem,
} from "../../../_helper/actions/mutation/items";
import { ApiEndPoint } from "../../../_helper/constant/api-types";
import { toast } from "react-toastify";
import { useNavigate, useParams } from "react-router-dom";
import { useAtom } from "jotai";
import { clinicAtom } from "../../../_helper/constant/constant-atom";
import { useItemsFilter } from "../../../_helper/actions/app/items";

const PharmacyForm = () => {
  const navigate = useNavigate("");
  const { id } = useParams();
  const [clinic, setClinic] = useAtom(clinicAtom);
  const [formData, setFormData] = useState({
    pharmacy_name: "",
    is_GST_applicable: false, // New field for GST applicability
    type: "Retail",
    city: "",
    state: "",
    zip_code: "",
    pharmacy_contact_number: "",
    email: "",
    pharmacy_email: "",
    gstin_number: "",
    address: "",
    authorized_person_name: "", // New field
    authorized_person_contact: "", // New field
    authorized_person_email: "", // New field
    is_standalone_pharmacy: false,
    inward_calculated_on_mrp: false, // Default value
    inward_calculate_on_wholesale_price: true,
  });

  const [stakeholders_sharing_id, setStakeholders_sharing_id] = useState([]);

  const mutation = useCreateItem(ApiEndPoint.PHARMACY);
  const update_mutation = useUpdateItem(ApiEndPoint.PHARMACY);

  const { data, isFetched } = useItemsFilter(
    ApiEndPoint.PHARMACY,
    `?action=getPharmacy&id=${id}`,
    id !== "new" ? true : false
  );

  console.log(data);

  useEffect(() => {
    isFetched && setStakeholders_sharing_id(data?.stakeholders_sharing_id);
    setFormData({
      ...data,
    });
  }, [isFetched]);

  const handleChange = (e) => {
    const { name, value, type, checked } = e.target;
    setFormData({ ...formData, [name]: type === "checkbox" ? checked : value });
  };

  const handlePartnerChange = (index, e) => {
    const { name, value } = e.target;
    const updatedPartners = [...stakeholders_sharing_id];
    updatedPartners[index][name] = value;
    setStakeholders_sharing_id(updatedPartners);
  };

  const addPartnerField = () => {
    setStakeholders_sharing_id([
      ...stakeholders_sharing_id,
      { name: "", share: 0 },
    ]);
  };

  const removePartnerField = (index) => {
    const updatedPartners = stakeholders_sharing_id.filter(
      (_, i) => i !== index
    );
    setStakeholders_sharing_id(updatedPartners);
  };

  const handleInwardCalculationChange = (basis) => {
    setFormData({
      ...formData,
      inward_calculated_on_mrp: basis === "MRP",
      inward_calculate_on_wholesale_price: basis === "Wholesale",
    });
  };

  console.log(formData);

  const handleSubmit = (e) => {
    e.preventDefault();

    const payload = {
      action: `${id === "new" ? "postPharmacy" : "patchPharmacy"}`,
      clinic_id: clinic.id,
      ...formData,
      type: formData.type ? formData.type : "Retail",
      stakeholders_sharing_id: [...stakeholders_sharing_id],
    };
    if (id == "new") {
      mutation.mutate(payload, {
        onSuccess: () => {
          navigate("/new/setup/warehouse");
          toast.success("New Pharmacy Added!");
        },
      });
    } else {
      update_mutation.mutate(
        { data: payload },
        {
          onSuccess: () => {
            navigate("/new/setup/warehouse");
            toast.success("Pharmacy Updated!");
          },
        }
      );
    }
  };

  return (
    <div className="bg-gray-50 min-h-screen py-12 ">
      <div className="bg-white shadow-md rounded-lg max-w-7xl mx-auto overflow-hidden">
        {/* Sticky Header */}
        <div className="bg-green-500 text-white text-center py-4 sticky top-0 z-1">
          <h2 className="text-2xl font-semibold">Pharmacy Setup</h2>
        </div>
        <div className="max-h-[75vh] overflow-y-auto p-6">
          <form onSubmit={handleSubmit} className="space-y-6">
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              {/* Pharmacy Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Pharmacy Name
                </label>
                <input
                  type="text"
                  name="pharmacy_name"
                  value={formData.pharmacy_name}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter Pharmacy Name"
                  required
                />
              </div>
              {/* Pharmacy Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  License No
                </label>
                <input
                  type="text"
                  name="license_no"
                  value={formData.license_no}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter License No"
                  required
                />
              </div>
              {/* Type */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Type
                </label>
                <select
                  name="type"
                  value={formData.type}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                >
                  <option value="Retail">Retail</option>
                  <option value="Wholesale">Wholesale</option>
                </select>
              </div>
              {/* Street Address */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Street Address
                </label>
                <input
                  type="text"
                  name="address"
                  value={formData.address}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter Street Address"
                  required
                />
              </div>
              {/* City */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  City
                </label>
                <input
                  type="text"
                  name="city"
                  value={formData.city}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter City"
                  required
                />
              </div>
              {/* State */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  State
                </label>
                <input
                  type="text"
                  name="state"
                  value={formData.state}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter State"
                  required
                />
              </div>
              {/* ZIP Code */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  ZIP Code
                </label>
                <input
                  type="text"
                  name="zip_code"
                  value={formData.zip_code}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter ZIP Code"
                  required
                />
              </div>
            </div>
            {/* Contact Information */}
            <div className="grid grid-cols-1 md:grid-cols-2 gap-6">
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Contact Number
                </label>
                <input
                  type="text"
                  name="pharmacy_contact_number"
                  value={formData.pharmacy_contact_number}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter Contact Number"
                  required
                />
              </div>
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Email
                </label>
                <input
                  type="email"
                  name="pharmacy_email"
                  value={formData.pharmacy_email}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter Email"
                  required
                />
              </div>
              {/* Authorized Persona Name */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Authorized Persona Name
                </label>
                <input
                  type="text"
                  name="authorized_person_name"
                  value={formData.authorized_person_name}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter Name"
                  required
                />
              </div>
              {/* Authorized Persona Contact */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Authorized Persona Contact
                </label>
                <input
                  type="text"
                  name="authorized_person_contact"
                  value={formData.authorized_person_contact}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter Contact"
                  required
                />
              </div>
              {/* Authorized Persona Email */}
              <div>
                <label className="block text-sm font-medium text-gray-700 mb-1">
                  Authorized Persona Email
                </label>
                <input
                  type="email"
                  name="authorized_person_email"
                  value={formData.authorized_person_email}
                  onChange={handleChange}
                  className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                  placeholder="Enter Email"
                  required
                />
              </div>

              {/* GST Applicable Checkbox */}
              <div className="flex items-center mt-4">
                <input
                  type="checkbox"
                  name="is_GST_applicable"
                  checked={formData.is_GST_applicable}
                  onChange={handleChange}
                  className="form-checkbox h-5 w-5 text-green-600"
                />
                <label className="ml-2 text-sm font-medium text-gray-700">
                  GST Applicable on Sales
                </label>
              </div>
              {/* GST Number (Conditional) */}
              {formData.is_GST_applicable && (
                <div className="mt-4">
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    GST Number
                  </label>
                  <input
                    type="text"
                    name="gstin_number"
                    value={formData.gstin_number}
                    onChange={handleChange}
                    className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                    placeholder="Enter GST Number"
                    required={formData.is_GST_applicable}
                  />
                </div>
              )}
            </div>
            {/* GST Calculation */}
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">
              GST Calculation for Inward
            </h3>
            <div className="flex items-center gap-4">
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="gstCalculationBasis"
                  value="MRP"
                  checked={formData.inward_calculated_on_mrp}
                  onChange={() => handleInwardCalculationChange("MRP")}
                  className="form-radio"
                />
                <span>Calculate on MRP</span>
              </label>
              <label className="flex items-center gap-2">
                <input
                  type="radio"
                  name="gstCalculationBasis"
                  value="Wholesale"
                  checked={formData.inward_calculate_on_wholesale_price}
                  onChange={() => handleInwardCalculationChange("Wholesale")}
                  className="form-radio"
                />
                <span>Calculate on Wholesale Price</span>
              </label>
            </div>
            {/* Stakeholder Sharing Section */}
            <h3 className="text-xl font-semibold text-gray-800 mt-6 mb-4">
              Stakeholder Sharing
            </h3>
            {stakeholders_sharing_id?.map((partner, index) => (
              <div
                key={index}
                className="grid grid-cols-1 md:grid-cols-3 gap-6 items-center"
              >
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Stakeholder Name
                  </label>
                  <input
                    type="text"
                    name="name"
                    value={partner.name}
                    onChange={(e) => handlePartnerChange(index, e)}
                    className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                    placeholder="Enter Stakeholder Name"
                  />
                </div>
                <div>
                  <label className="block text-sm font-medium text-gray-700 mb-1">
                    Share (%)
                  </label>
                  <input
                    type="number"
                    name="share"
                    value={partner.share}
                    onChange={(e) => handlePartnerChange(index, e)}
                    className="border border-gray-300 rounded-lg px-4 py-2 w-full focus:ring focus:ring-green-200"
                    placeholder="Enter Share Percentage"
                  />
                </div>
                <div className="flex items-center justify-end space-x-4">
                  {stakeholders_sharing_id?.length > 0 && (
                    <button
                      type="button"
                      className="flex items-center text-red-500 hover:text-red-700"
                      onClick={() => removePartnerField(index)}
                    >
                      <FaTrash className="mr-2" />
                      <span>Remove</span>
                    </button>
                  )}
                </div>
              </div>
            ))}
            <div className="flex justify-end mt-4">
              <button
                type="button"
                className="flex items-center text-green-500 hover:text-green-700"
                onClick={addPartnerField}
              >
                <FaPlus className="mr-2" />
                <span>Add Stakeholder</span>
              </button>
            </div>
            {/* Submit Button */}
            <div className="flex justify-end mt-6">
              <button
                type="button"
                className="bg-gray-300 text-gray-700 px-4 py-2 rounded-lg mr-2 hover:bg-gray-400"
              >
                Cancel
              </button>
              <button
                type="submit"
                className="bg-green-500 text-white px-4 py-2 rounded-lg hover:bg-green-600"
              >
                Save
              </button>
            </div>
          </form>
        </div>
      </div>
    </div>
  );
};

export default PharmacyForm;
